import {useTranslation} from "react-i18next";

export const activityCategory = () => {
  const {t} = useTranslation();

  return [
    {id: "RIVER_JOURNEY", name: t('activity_categories.river_journey')},
    {id: "WINE_TASTING", name: t('activity_categories.wine_tasting')},
    {id: "GASTRONOMY", name: t('activity_categories.gastronomy')},
    {id: "AMAZING_MOMENT", name: t('activity_categories.amazing_moment')},
    {id: "OTHER", name: t('activity_categories.other')},
  ];
}


